<script>
  // src/PopupMap.svelte
  import Popup from "./Popup.svelte";
  import Markdown from "svelte-markdown";
  import { tourFunctions } from "../tour-functions";
  const { parseContent } = tourFunctions;

  import UAParser from "ua-parser-js";
  let parser = new UAParser();
  let os = parser.getOS();

  const tourUrl = "https://tours.covecreekproductions.com/toledo_map/";

  // Icons
  import IconDirections from "./IconDirections.svelte";
  import IconWalk from "./IconWalk.svelte";
  import IconCar from "./IconCar.svelte";
  import Icon360 from "./Icon360.svelte";

  // Exports
  export let image;
  export let title;
  export let content;
  export let linkedscenes = [];
  export let driveLocation;
  export let walkLocation;
  export let directions;
  export let visible = true;
  

  if (content) content = parseContent(content);

  const directionsUrl = generateMapUrl(directions, "walking");
  const walkUrl = generateMapUrl(walkLocation, "walking");
  const driveUrl = generateMapUrl(driveLocation, "driving");

  if (linkedscenes) {
    linkedscenes.forEach((s) => {
      s.url = `${tourUrl}?startscene=${s.name}`;
    });
    // Filter out scenes without a name or title
    linkedscenes = linkedscenes.filter((s) => s.name && s.title);
  }

  // replace [br] tags with spaces
  function displayTitle(title) {
    return title.replace(/\[br\]/g, " ");
  }

  function generateMapUrl(location, transportation) {
    if (!location) return;

    const baseUrl = "https://www.google.com/maps/dir/";
    // array or object with {lat, lng}
    if (Array.isArray(location)) {
      location = { lat: location[1], lng: location[0] };
    }

    const coordinates = `${location.lat},${location.lng}`;

    if (os.name === "iOS") {
      return `http://maps.apple.com/?daddr=${coordinates}&t=s`;
    } else {
      let travelMode;

      if (transportation === "walking") {
        travelMode = "data=!3m1!4b1!4m2!4m1!3e2";
      } else if (transportation === "driving") {
        travelMode = "data=!4m2!4m1!3e0";
      } else {
        travelMode = "";
      }

      return `${baseUrl}${coordinates}/@${coordinates},12z/${travelMode}`;
    }
  }

  function loadScene(sceneName) {
    tourFunctions.loadScene(sceneName, "map_popup");
    if (window.CC.switchView) window.CC.switchView();
    visible = false;
  }
</script>

<Popup {visible}>
  <div class="popup">
    <!-- {#if image}
  <div class="image column" style={`background-image: url(${image});`}></div>
  {/if} -->

    <div class="content column">
      <div class="content-header">
        <h2 class="title">{displayTitle(title)}</h2>
      </div>
      <div class="actions" class:wide={linkedscenes.length > 1}>
        <!-- Walking Link -->
        {#if walkLocation}
          <button 
            class="link icon-text" 
            on:click={() => window.open(walkUrl, '_blank')}
            aria-label="Walk to this location"
          >
            <div class="icon-container">
              <IconWalk size={"0.65em"} fill="#fff" />
            </div>
            <span>Walk to this location</span>
          </button>
        {/if}
        <!-- Driving Link -->
        {#if driveLocation}
          <button 
            class="link icon-text" 
            on:click={() => window.open(driveUrl, '_blank')}
            aria-label="Drive to this location"
          >
            <div class="icon-container">
              <IconCar size={"1.5em"} fill="#fff" />
            </div>
            <span>Drive to this location</span>
          </button>
        {/if}
        <!-- Directions Link -->
        {#if directions}
          <button 
            class="link icon-text" 
            on:click={() => window.open(directionsUrl, '_blank')}
            aria-label="Get directions to this location"
          >
            <div class="icon-container">
              <IconDirections size={"1.5em"} fill="#fff" />
            </div>
            <span>Directions to this location</span>
          </button>
        {/if}
        <!-- 360 Pano Link Multiple -->
        {#if linkedscenes.length > 1}
          <div class="linkedscenes">
            <h3 class="icon-text">
              <div class="icon-container">
                <Icon360 fill="#fff" size={"1.5em"} />
              </div>
              <span>Open in Virtual Tour:</span>
            </h3>

            <ul>
              {#each linkedscenes as scene}
                <li>
                  <button
                    class="link"
                    on:click={() => loadScene(`${scene.name}`)}
                    aria-label="Open {scene.title} in virtual tour"
                  >
                    {scene.title}
                  </button>
                </li>
              {/each}
            </ul>
          </div>
        {/if}
        <!-- 360 Pano Link Single -->
        {#if linkedscenes.length == 1}
          <button
            class="link icon-text"
            on:click={() => loadScene(`${linkedscenes[0].name}`)}
            aria-label="Open {linkedscenes[0].title} in virtual tour"
          >
            <div class="icon-container">
              <Icon360 fill="#fff" size={"1.5em"} />
            </div>
            <span>Open in Virtual Tour</span>
          </button>
        {/if}
      </div>
      {#if content}
        <div class="content-inner">
          <!-- <Markdown source={content} /> -->
          {@html content}
        </div>
      {/if}
    </div>
  </div>
</Popup>

<style>
  .popup {
    padding-top: 2rem;
    font-family: var(--font-body), sans-serif;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    height: 100%;
  }

  .image {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .content {
    justify-content: center;
    align-items: center;
    /* text-align: center; */
  }

  .content-header {
    padding: 0 1rem;
  }

  .content-inner {
    text-align: left;
    line-height: 1.65em;
    padding: 0 1rem;
    overflow-y: scroll;
    max-height: 400px;
  }

  /* :global(.popup .content-inner a) {
    color: #fff;
    font-weight: 500;
  } */

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #fff;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }

  a {
    color: #fff;
    text-decoration: underline;
  }

  a:hover,
  a:hover span {
    font-weight: bold;
  }

  .actions {
    padding: 0;
  }

  .actions.wide {
    width: calc(100% - 2rem);
  }

  .title {
    font-size: 2rem;
    font-weight: 900;
    margin: 0;
    margin-bottom: 0.25em;
  }

  .button {
    background: #000;
    padding: 0.75rem;
    color: #fff;
    border-radius: 5px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .button:hover {
    background: #333;
  }

  .button span {
    margin-left: 0.5em;
  }

  .link {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    background: none;
    border: none;
    color: #fff;
    text-decoration: underline;
    padding: 0;
    font: inherit;
  }

  .link:hover,
  .link:hover span {
    font-weight: bold;
  }

  .link:focus {
    outline: none;
    box-shadow: 0 0 0 4px var(--focus-color);
    border-radius: 4px;
  }

  .icon-text {
    display: inline-flex;
    align-items: center;
  }

  .icon-text span {
    margin: 0 0.5em;
    font-weight: 500;
  }

  .icon-container {
    width: 1.5em;
    height: 1.5em;
    text-align: center;
  }

  .linkedscenes {
    /* padding: 0 0 1em 0; */
    padding: 0;
    display: block;
    vertical-align: middle;
  }

  .linkedscenes h3 {
    margin-bottom: 0.25em;
  }

  .linkedscenes ul {
    padding-left: 40px;
    list-style: none;
    margin: 0;
  }

  .linkedscenes li {
    margin-bottom: 0.5em;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 1.5em;
    }
  }
</style>
